var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedianetworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "408.538 40.197 681.745 673.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1089.747 258.656h-.054L980.571 149.427l109.122-109.23h.054zm.536 227.409-.054.053-109.122-109.282 109.122-109.23.054.054zm0 227.462h-.054L981.107 604.299l109.122-109.23h.054zM977.141 599.796h-.053V381.392l.053-.054 109.175 109.229zm0-227.409-.053-.053V153.929h.053l109.175 109.229zm-.053 227.409L867.966 490.567l109.122-109.175zm0-227.462L867.966 263.158l109.122-109.229zm-4.181 4.233.107.108-109.175 109.229-109.176-109.229.054-.108z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m754.717 376.729-.054-.054 109.176-109.23 109.175 109.23-.107.054zm-4.342 223.067V381.338l109.176 109.229zm0 0L641.253 490.567l109.122-109.229zm-4.717-223.229.054.108-109.176 109.229-109.122-109.229.054-.108z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m527.468 376.729-.054-.054 109.122-109.23 109.176 109.23-.054.054zm-5.252 223.067V381.392l109.122 109.175zm0-227.462V153.929l109.122 109.229zm0 227.462h-.054L413.04 490.567l109.122-109.229.054.054zm0-227.462-.054.053L413.04 263.158l109.122-109.229h.054zM408.538 713.527V495.069l109.176 109.23zm0-227.409V267.606l109.176 109.23zm0-227.462V40.197l109.176 109.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedianetworks);
export default __webpack_public_path__ + "static/media/medianetworks.4b52d1244069b519abb779943ea596a4.svg";
export { ForwardRef as ReactComponent };